"use strict";

exports.__esModule = true;
exports.getDefaultRegistry = getDefaultRegistry;

var _fields = _interopRequireDefault(require("../fields/"));

var _fieldtypes = _interopRequireDefault(require("../fieldtypes/"));

var _widgets = _interopRequireDefault(require("../widgets/"));

var _layouts = _interopRequireDefault(require("../layouts/"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefaultRegistry() {
  return {
    fields: _fields.default,
    fieldtypes: _fieldtypes.default,
    widgets: _widgets.default,
    layouts: _layouts.default,
    definitions: {},
    formContext: {}
  };
}